const loginModule = {
  login: "회원 로그인",
  phonePlaceholder: "휴대 전화 번호를 입력하주세요.",
  emailPlaceholder: "편지함을 입력하십시오",
  passwordPlaceholder: "비밀번호를 입력하주세요.",
  register: "회원가입",
  forgetText: "비밀번호  잊음",
  ruleText1: "이용약관",
  ruleText2: "개인정보 수집",
  ruleText3: "동의",
  rule: "이용 약관",
  questionText: "로그인에 문제가 있는 경우",
  questionSubText: "사용 가능한 기능 부분 제한",
  otherLogin: "기타 로그인",
  otherLoginText: "다른 방식으로 로그인",
  routeLoading: "건너뛰기 중...",
  returnLogin: "나가기",
  visitorsLogin: "방문자 로그인",
  agentWarn: "[익명 로그인] 비마크 모드를 사용하거나 브라우저 캐시를 비울 경우 사용자 정보가 손실될 수 있습니다.",
  emailPlaceholder: "편지함을 입력하십시오",
  accountExample: "ID(例：08012341234)",
  lineLogin: "LINE로그인",
  lineLoginDesc: "line에서 사용하려면'line 등록'을 누른 후'허가'를 눌러 주십시오.",
  nohaveAccount: "계좌번호 없나요?"
};

export default loginModule;
